/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable prefer-destructuring */
import { useEffect, useState, useRef } from 'react';
import moment from 'moment';
import { useHistory, useLocation } from 'react-router-dom';
import { FaDownload } from 'react-icons/fa';
import Container from '~/components/container';

import * as St from './styles';
import FilterBiometrics from './components/FilterBiometrics';
import ContainerFlex from '~/components/containerFlex';
import TableList from '~/components/tableList';
import useApi, { ApiMethod } from '~/hooks/useApi';
import Endpoints from '~/services/endpoints';
import Loading from '~/components/loading';
import Pagination from '~/components/pagination';
import Button from '~/components/button';
import { useFilterBiometrics } from './context/FilterBiometricContext';
import { BiometriaUnicoDisplay } from './models';
import { cpfMask } from '~/utils/masks';
import { runDownloadTask } from '~/utils/runDownloadTask';

interface BiometricsResponse {
  currentPage: number;
  items: any[];
  totalPages: number;
  pageSize: number;
}

export interface BiometricsItem {
  codigoLiveness: string;
  codigoTransacional: string;
  dataCriacao: string;
  nomeCompleto: string;
  origemBiometria: string;
  ticket: string;
}
export const OriginBiometrics = (origin) => {
  switch (origin) {
    case 'TODAS':
      return 'Todas';
    case 'T_SENHA':
      return 'Alteração de senha';
    case 'T_SENHA_CHANGE_PROFILE':
      return 'Alteração de senha no perfil';
    case 'T_EMPRESTIMO':
      return 'Empréstimo Hotmoney';
    case 'T_CHANGE_PERSONAL_DATA':
      return 'Alteração de dados';
    case 'T_DEVICE_ID':
      return 'Device ID';
    case 'PROPOSTA':
      return 'Proposta';
    case 'T_ADD_CARD_WALLET':
      return 'Adicionar cartão na carteira';
    case 'T_REPRINT_CARD':
      return 'Reimpressão de cartão';
    case 'T_INSTALLMENT_TEUCARD':
      return 'Limite parcelado 12x';
    default:
      return '';
  }
};

const ConsultFacialBiometrics = () => {
  const {
    form,
    setForm,
    list,
    setList,
    setCurrentPage,
    currentPage,
  } = useFilterBiometrics();
  const [listUnico, setListUnico] = useState<any[]>([]);
  const [listaBankNow, setListaBankNow] = useState<any[]>([]);
  const prevBiometriaType = useRef(form.biometriaType);
  const [totalPages, setTotalPages] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const history = useHistory();

  const { state } = useLocation<{ fromDetail?: boolean }>();

  const customHeaderUnico = [
    {
      id: 1,
      value: 'Nome completo',
      maxChar: 20,
      textAlign: 'center',
    },
    {
      id: 2,
      value: 'Data validação',
      maxChar: 10,
      textAlign: 'center',
    },
    {
      id: 3,
      value: 'Hora da validação',
      maxChar: 10,
      textAlign: 'center',
    },
    {
      id: 4,
      value: 'Origem Biometria',
      maxChar: 20,
      textAlign: 'center',
    },
    {
      id: 5,
      value: 'Resultado Autenticação',
      maxChar: 20,
      textAlign: 'center',
    },
    {
      id: 6,
      value: 'Resultado Alerta Comportamento',
      maxChar: 20,
      textAlign: 'center',
    },
    {
      id: 7,
      value: 'Ação',
      maxChar: 10,
      textAlign: 'center',
    },
  ];

  const customHeaderBankNow = [
    { id: 1, value: 'Nome completo', maxChar: 20, textAlign: 'center' },
    { id: 2, value: 'Data validação', maxChar: 10, textAlign: 'center' },
    { id: 3, value: 'Hora da validação', maxChar: 10, textAlign: 'center' },
    { id: 4, value: 'Origem Biometria', maxChar: 20, textAlign: 'center' },
    {
      id: 5,
      value: 'Resultado Autenticação',
      maxChar: 20,
      textAlign: 'center',
    },
    { id: 6, value: 'CPF', maxChar: 15, textAlign: 'center' },
    { id: 7, value: 'Ação', maxChar: 10, textAlign: 'center' },
  ];

  const RequestUnicoBiometrics = useApi<BiometricsResponse>(
    Endpoints.integration.getUnicoBiometrics,
    ApiMethod.GET,
    {},
    true,
  );

  const RequestBankNowBiometrics = useApi<BiometricsResponse>(
    Endpoints.integration.getBankNowBiometrics,
    ApiMethod.GET,
    {},
    true,
  );

  const RequestCertifaceCSV = useApi(
    Endpoints.integration.getCertifaceExportCSV,
    ApiMethod.GET,
    {},
    true,
  );

  const RequestUnicoExportCSV = useApi(
    Endpoints.integration.getUnicoExportCSV,
    ApiMethod.GET,
    {},
    true,
  );

  const getCertifaceReportCSVDownload = async () =>
    runDownloadTask(async () => {
    try {
      const response = await RequestCertifaceCSV.callApi({
        cpf: form.cpf?.unmasked,
        origem: form?.origem,
        start: form.dataBiometriaInicial
          ? moment(form.dataBiometriaInicial, 'DD/MM/YYYY').format('YYYY-MM-DD')
          : '',
        end: form.dataBiometriaFinal
          ? moment(form.dataBiometriaFinal, 'DD/MM/YYYY').format('YYYY-MM-DD')
          : '',
        id_faces: form.baseResultFace ? form.baseResultFace : '',
        id_liveness: form.resultLiveness ? form.resultLiveness : '',
      });

      if (response.status === 200) {
        const blob = new Blob([response.data as Blob], {
          type: 'text/csv;charset=UTF-8',
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'relatorio_certiface.csv';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.log(error);
    }
    });

  const getUnicoReportCSVDownload = async () =>
    runDownloadTask(async () => {
    try {
      const params: any = {
        cpf: form.cpf?.unmasked,
        start: form.dataBiometriaInicial
          ? moment(form.dataBiometriaInicial, 'DD/MM/YYYY').format('YYYY-MM-DD')
          : '',
        end: form.dataBiometriaFinal
          ? moment(form.dataBiometriaFinal, 'DD/MM/YYYY').format('YYYY-MM-DD')
          : '',
        id_auth: form.codigoAutenticacao ? form.codigoAutenticacao : '',
        id_trust: form.codigoComportamento ? form.codigoComportamento : '',
      };

      const response = await RequestUnicoExportCSV.callApi(params);

      if (response.status === 200) {
        const blob = new Blob([response.data as Blob], {
          type: 'text/csv;charset=UTF-8',
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'relatorio_unico.csv';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.log(error);
    }
    });

  const handleDownloadReport = () => {
    if (form.biometriaType === 'unico') {
      getUnicoReportCSVDownload();
    } else {
      getCertifaceReportCSVDownload();
    }
  };

  const buildParams = () => {
    if (form.biometriaType === 'banknow') {
      const params: any = {
        cpf: form.cpf?.unmasked,
        start: form.dataBiometriaInicial
          ? moment(form.dataBiometriaInicial, 'DD/MM/YYYY').format('YYYY-MM-DD')
          : '',
        end: form.dataBiometriaFinal
          ? moment(form.dataBiometriaFinal, 'DD/MM/YYYY').format('YYYY-MM-DD')
          : '',
        page: currentPage,
        origem: form.origem,
        status: form?.status,
        size: pageSize,
      };
      return params;
    }
    if (form.biometriaType === 'unico') {
      const params: any = {
        cpf: form.cpf?.unmasked,
        start: form.dataBiometriaInicial
          ? moment(form.dataBiometriaInicial, 'DD/MM/YYYY').format('YYYY-MM-DD')
          : '',
        end: form.dataBiometriaFinal
          ? moment(form.dataBiometriaFinal, 'DD/MM/YYYY').format('YYYY-MM-DD')
          : '',
        id_auth: form.codigoAutenticacao ? form.codigoAutenticacao : '',
        id_trust: form.codigoComportamento ? form.codigoComportamento : '',
        page: currentPage,
        size: pageSize,
      };
      return params;
    }
  };

  const getBiometrics = async () => {
    if (form.biometriaType === 'banknow') {
      const response = await RequestBankNowBiometrics.callApi(buildParams());
      if (response.status === 200) {
        const { items, totalPages, pageSize } = response.data;
        setTotalPages(totalPages);
        setPageSize(pageSize);

        return items.map((data: any, index: number) => {
          const dataValida =
            data?.createdDate && moment(data.createdDate).isValid();
          return [
            {
              key: `banknow-${index}`,
              border: true,
              title: 'Nome completo',
              value: data?.name || '-',
              maxChar: 20,
            },
            {
              key: `banknow-date-${index}`,
              title: 'Data de validação',
              value: dataValida
                ? moment(data.createdDate).format('DD/MM/YYYY')
                : '-',
              textAlign: 'center',
            },
            {
              key: `banknow-time-${index}`,
              title: 'Hora de validação',
              value: dataValida
                ? moment(data.createdDate).format('HH:mm:ss')
                : '-',
              textAlign: 'center',
            },
            {
              key: `banknow-origin-${index}`,
              title: 'Origem Biometria',
              value: data?.flow ? OriginBiometrics(data?.flow) : '-',
              textAlign: 'center',
            },
            {
              key: `banknow-auth-${index}`,
              title: 'Resultado Autenticação',
              value: data?.status || '-',
              textAlign: 'center',
            },
            {
              key: `banknow-cpf-${index}`,
              title: 'CPF',
              value: data?.code ? cpfMask(data?.code).masked : '-',
              maxChar: 15,
              textAlign: 'center',
            },
            {
              key: `banknow-action-${index}`,
              item: data,
              searchAction: () => goToBankNowDetail(data),
            },
          ];
        });
      }
      return null;
    }

    if (form.biometriaType === 'unico') {
      const response = await RequestUnicoBiometrics.callApi(buildParams());
      if (response.status === 200) {
        const { items, totalPages, pageSize } = response.data;
        setTotalPages(totalPages);
        setPageSize(pageSize);

        return items.map((data, index) => {
          const dataValida =
            data.dataCriacao && moment(data.dataCriacao).isValid();
          return [
            {
              key: `unico-${data.processId || index}`,
              border: true,
              title: 'Nome completo',
              value: data.nomeCompleto || '-',
              maxChar: 20,
            },
            {
              key: `unico-date-${data.processId || index}`,
              title: 'Data de validação',
              value: dataValida
                ? moment(data.dataCriacao).format('DD/MM/YYYY')
                : '-',
              textAlign: 'center',
            },
            {
              key: `unico-time-${data.processId || index}`,
              title: 'Hora de validação',
              value: dataValida
                ? moment(data.dataCriacao).format('HH:mm:ss')
                : '-',
              textAlign: 'center',
            },
            {
              key: `unico-origin-${data.processId || index}`,
              title: 'Origem Biometria',
              value: data.origem || '-',
              textAlign: 'center',
            },
            {
              key: `unico-auth-${data.processId || index}`,
              title: 'Resultado Autenticação',
              value: BiometriaUnicoDisplay[data?.resultadoAutenticacao] || '-',
              textAlign: 'center',
            },
            {
              key: `unico-trust-${data.processId || index}`,
              title: 'Resultado Alerta Comportamento',
              value:
                BiometriaUnicoDisplay[data?.resultadoAlertaComportamento] ||
                '-',
              textAlign: 'center',
            },
            {
              key: `unico-action-${data.processId || index}`,
              item: data,
              searchAction: () => goToDetail(data.processId, data.cpf),
            },
          ];
        });
      }
      return null;
    }

    return null;
  };

  const handleSubmit = (page = 1) => {
    if (isSubmitting) return;

    setIsSubmitting(true);
    setCurrentPage(page);
  };

  useEffect(() => {
    // Limpa a lista correta ao trocar o tipo de biometria
    if (prevBiometriaType.current !== form.biometriaType) {
      if (form.biometriaType === 'unico') {
        setListUnico([]);
      }
      if (form.biometriaType === 'banknow') {
        setListaBankNow([]);
      }
      prevBiometriaType.current = form.biometriaType;
    }
  }, [form.biometriaType, setList]);

  useEffect(() => {
    const fetchData = async () => {
      const data = await getBiometrics();
      if (form.biometriaType === 'unico') {
        setListUnico(data || []);
      }
      if (form.biometriaType === 'banknow') {
        setListaBankNow(data || []);
      }
      setIsSubmitting(false);
    };

    fetchData();
  }, [currentPage, isSubmitting]);

  const goToDetail = (id: string, cpf: string) => {
    if (form.biometriaType === 'unico') {
      // Redirecionar para detalhes Unico
      history.push('/consult/user/biometrics/unico/detail', {
        id,
        biometriaType: 'unico',
        cpf: form.cpf?.unmasked || cpf,
        fromDetail: true,
      });
    } else {
      // Redirecionar para detalhes Certiface
      history.push('/consult/user/biometrics/detail', {
        id,
        biometriaType: 'certiface',
        fromDetail: true,
      });
    }
  };

  const goToBankNowDetail = (row: any) => {
    history.push('/consult/user/biometrics/banknow/detail', {
      item: row,
      biometriaType: 'banknow',
      cpf: form.cpf?.unmasked,
      fromDetail: true,
    });
    return;
  };

  useEffect(() => {
    if (state?.fromDetail) {
      handleSubmit(currentPage);
      history.replace({ ...history.location, state: {} });
    }
  }, [state, currentPage]);

  // useEffect(() => {
  //   const cpfFilled = form.cpf?.unmasked && form.cpf.unmasked.length === 11;
  //   const datesFilled = form?.dataBiometriaInicial && form?.dataBiometriaFinal;

  //   if ((cpfFilled || (datesFilled && form.origem)) && !isSubmitting) {
  //     handleSubmit(currentPage);
  //   }
  // }, [currentPage]);

  const renderSection = () => {
    const type = form.biometriaType;
    const map = {
      unico: { header: customHeaderUnico, data: listUnico, showDownload: true },
      banknow: {
        header: customHeaderBankNow,
        data: listaBankNow,
        showDownload: false,
      },
    } as const;

    const cfg = map[type as keyof typeof map] || map.banknow;

    if (!cfg.data || cfg.data.length <= 0) {
      return (
        <St.BoxCard>
          <ContainerFlex center>
            <span>Dados biométricos não encontrados</span>
          </ContainerFlex>
        </St.BoxCard>
      );
    }

    return (
      <St.BoxCard>
        <ContainerFlex flex="0.2">
          <>
            {cfg.showDownload && (
              <ContainerFlex end flex="0.2" marginBottom={30}>
                <Button fitContent onClick={handleDownloadReport}>
                  <FaDownload />
                  <span style={{ marginLeft: '8px' }}>Download</span>
                </Button>
              </ContainerFlex>
            )}
            <ContainerFlex>
              <TableList customerHeader={cfg.header} list={cfg.data} />
            </ContainerFlex>
            <ContainerFlex marginTop={20} center flex={1}>
              <Pagination
                totalPages={totalPages}
                initialCurrentPage={currentPage}
                onCurrentPageChange={setCurrentPage}
              />
            </ContainerFlex>
          </>
        </ContainerFlex>
      </St.BoxCard>
    );
  };

  return (
    <>
      <Loading
        status={
          RequestCertifaceCSV?.loading ||
          RequestUnicoBiometrics?.loading ||
          RequestUnicoExportCSV?.loading ||
          RequestBankNowBiometrics?.loading
        }
      />
      <Container>
        <FilterBiometrics
          onClick={() => {
            handleSubmit(1);
          }}
        />
        {renderSection()}
      </Container>
    </>
  );
};

export default ConsultFacialBiometrics;
